import PageHeader from "../components/PageHeader";
import PortfolioCard from "../components/PortfolioCard";
import { GradientButton } from "../components/primitives";
import { PORTFOLIO } from "../data/content";

export default function Portfolio() {
  return (
    <div data-testid="portfolio-page">
      <PageHeader
        eyebrow="Portfolio"
        title="Crafted for real businesses"
        sub="A selection of projects across industries — each built to look premium, load fast, and convert visitors into customers."
      />

      <section className="mx-auto max-w-7xl px-5 pb-8 lg:px-8">
        <div className="grid gap-6 lg:grid-cols-2">
          {PORTFOLIO.map((p, i) => (
            <PortfolioCard key={p.id} project={p} index={i} large={i === 0} />
          ))}
        </div>
      </section>

      <section className="mx-auto max-w-3xl px-5 py-24 text-center lg:px-8">
        <h2 className="font-heading text-3xl font-semibold text-white sm:text-4xl">
          Your project could be <span className="text-gradient">next</span>.
        </h2>
        <p className="mx-auto mt-4 max-w-xl text-base text-muted-foreground">
          We'd love to hear what you're building. Let's talk about how we can bring it to life.
        </p>
        <div className="mt-8 flex justify-center">
          <GradientButton to="/contact" data-testid="portfolio-cta">Start Your Project</GradientButton>
        </div>
      </section>
    </div>
  );
}
